import { useTranslation } from 'react-i18next';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox1,
  TextBox2,
  SectionContainer,
} from './SectionSix.style';

const SectionSix = () => {
  const { t } = useTranslation('home');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>
          {t('sectionSix.title')}
          <span>2</span> AI
        </h1>
        <StyledHr />
      </SectionWrapper>
      <ContentWrapper>
        {/* Primeira fileira */}
        <div>
          <TextBox1>
            <p>{t('sectionSix.subtitleOne')}</p>
            <TextBox2>
              <p>{t('sectionSix.paragraphOne')}</p>
            </TextBox2>
          </TextBox1>
        </div>
        <div>
          <TextBox1>
            <p>{t('sectionSix.subtitleTwo')}</p>
            <TextBox2>
              <p>{t('sectionSix.paragraphTwo')}</p>
            </TextBox2>
          </TextBox1>
        </div>
        <div>
          <TextBox1 className="empty-content">
            <p></p>
            <TextBox2>
              <p></p>
            </TextBox2>
          </TextBox1>
        </div>

        {/* Segunda fileira */}
        <div>
          <TextBox1 className="empty-content">
            <p></p>
            <TextBox2>
              <p></p>
            </TextBox2>
          </TextBox1>
        </div>
        <div>
          <TextBox1 className="content-left">
            <p>{t('sectionSix.subtitleThree')}</p>
            <TextBox2>
              <p>{t('sectionSix.paragraphThree')}</p>
            </TextBox2>
          </TextBox1>
        </div>
        <div>
          <TextBox1 className="content-left">
            <p>{t('sectionSix.subtitleFour')}</p>
            <TextBox2>
              <p>{t('sectionSix.paragraphFour')}</p>
            </TextBox2>
          </TextBox1>
        </div>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default SectionSix;
